export const addInfoData = (data, options = {}) => {
    const { keys = Object.keys(data), prefix = '##$' } = options;
    let header = '';
    for (const key of keys) {
        header +=
            typeof data[key] === 'object'
                ? `${prefix}${key}=${JSON.stringify(data[key])}\n`
                : `${prefix}${key}=${data[key]}\n`;
    }
    return header;
};
//# sourceMappingURL=addInfoData.js.map